/**
 * Tiempo durante el cual el catálogo se considera fresco. Evita volver a pedirlo al montar de nuevo la
 * pantalla mientras el dato siga vigente. Se usa el mismo valor para `cacheTime` —así se llama en
 * react-query 3— para conservar la caché mientras pueda reutilizarse.
 */
export const STALE_TIME = 5 * 60_000; // 5 min
